import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { auth } from './auth';
import { documentApi2 } from './document-viewer/document-api';

type IdleTimeoutProps = {
  timeout?: number;
};

export const idleTimeoutChannel = new window.BroadcastChannel(
  'idleTimeoutEvent'
);

const defaultTimeout = 1000 * 60 * 15;
const promptTimeout = 1000 * 30;

const openId = Date.now();


export function IdleTimeout(props?: IdleTimeoutProps) {
  const { timeout } = props;
  const [open, setOpen] = useState(false);

  const onPrompt = () => {
    setOpen(true);
    setRemaining(promptTimeout);
  };

  const onIdle = () => {
    setOpen(false);
    setRemaining(0);
    documentApi2.closeWindow();
    auth.signOut();
    
  };

  const onActive = () => {
    setOpen(false);
    setRemaining(0);
  };

  const onAction = () => {
    idleTimeoutChannel.postMessage(openId);
  };

  const onContinue = () => {
    restart();
    idleTimeoutChannel.postMessage(openId);
  };

  const restart = () => {
    console.log('restart');
    reset();
    start();
    setOpen(false);
  };

  const { start, reset, isPrompted, getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    onPrompt,
    promptTimeout,
    timeout: timeout || defaultTimeout,
    startManually: true,
  });

  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    idleTimeoutChannel.onmessage = (e) => {
      if (e.data !== openId) {
        restart();
      }
    };
    start();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPrompted()) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, isPrompted]);

  return (
    <Dialog open={open} maxWidth={false}>
      <DialogTitle style={{ paddingBottom: 0 }}>
        Are you still there?
      </DialogTitle>
      <DialogContent style={{ width: 340, textAlign: 'justify' }}>
        You will be logged out automatically in {remaining} seconds.
        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={onIdle} color="primary" variant="outlined">
          {' '}
          Logout{' '}
        </Button>
        <Button onClick={onContinue} color="primary" variant="contained">
          {' '}
          Continue{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
